export class BookingRequestDto {
    id: number;
    merchantId?: number;
    noPersons?: number;
    bookingDate?: Date;
    startDateTime? : Date;
    endDateTime?: Date;
    bookingDateAsInt?: number;
    startTimeAsInt?: number;
    endTimeAsInt?: number;
    customerId?: number;
    merchantSaleUnitIds: string;
    merchantSaleRoomId: number;
    notes: string;
    bookingName: string;
    phoneNumber: string;
    emailAddress: string;
    statusId: number;
    lastStatusId: number;
  }
  